import Icon from 'veui/components/Icon'
import { IconVideoCrop } from 'dls-icons-vue'

Icon.register('video-crop', IconVideoCrop)
